import moneyDisplay from "../../../../components/moneyDisplay/moneyDisplay";
import { connect } from "react-redux";
import { asPercentage } from "../../../../utils/formatters";
export default connect(state => ({
  value: asPercentage(state.firstRiders.firstTimeRiders.closing.closingPercentYTD),
  currency: "%",
  size: 35,
  currencyLocation: "end",
  color: "rgb(142, 191, 251)",
  disableAnimation: state.firstRiders.currentUser.qa
}))(moneyDisplay);
